import AddressDisplay from 'App/DetailsPage/common/AddressDisplay/AddressDisplay';
import DeliveryNoteIcon from 'assets/dialogue-avatar-delivery-note.svg';
import { DialogueCardData, DialogueType } from 'models/DialogCard';
import { ArticleAddress, Milestone, RedirectStatus } from 'models/shipments';
import { formatAddress } from 'utils/string.utils';

const comingTodayConfig = {
  noAddress: (
    <p>
      There was a problem processing the recipient’s request, so this parcel will be delivered to the previous address
      instead.
    </p>
  ),
  withAddress: (addressLines: string[]) => (
    <>
      <p>There was a problem processing the recipient’s request, so this parcel will be delivered to:</p>
      <AddressDisplay addressLines={addressLines} />
    </>
  ),
};

const deliveredConfig = {
  noAddress: (
    <p>
      There was a problem processing the recipient’s request, so this parcel was delivered to the previous address
      instead.
    </p>
  ),
  withAddress: (addressLines: string[]) => (
    <>
      <p>There was a problem processing the recipient’s request, so this parcel was delivered to:</p>
      <AddressDisplay addressLines={addressLines} />
    </>
  ),
};

export function getFailedRedirectionCard(
  redirectStatus: RedirectStatus | null,
  latestMilestone: string | null,
  address: Partial<ArticleAddress> | null
): DialogueCardData | null {
  if (redirectStatus !== RedirectStatus.REDIRECT_FAILED || !latestMilestone) return null;

  let contentConfig;
  let analyticsId: string;

  switch (latestMilestone) {
    case Milestone.COMING_TODAY:
      analyticsId = 'failedRedirectionComingToday';
      contentConfig = comingTodayConfig;
      break;
    case Milestone.DELIVERED:
      analyticsId = 'failedRedirectionDelivered';
      contentConfig = deliveredConfig;
      break;
    default:
      return null;
  }

  const addressLines = (address && formatAddress(address)) || null;
  const content = addressLines?.length ? contentConfig.withAddress(addressLines) : contentConfig.noAddress;

  return {
    analyticsId,
    title: 'We couldn’t redirect it',
    type: DialogueType.DELIVERY_NOTE,
    icon: <DeliveryNoteIcon />,
    content,
  };
}
